<template>
    <v-layout row wrap>
        <!-- <v-flex xs6>
            <v-flex md6 class="meeting-tools__links">
                <i class="fas fa-calendar-alt"></i>
                <v-flex tag="strong">{{toolKitConstants.MY_MEETINGS}}</v-flex>
            </v-flex>
        </v-flex> -->
        <v-flex xs6 mx-auto>
            <v-flex
                md6
                class="meeting-tools__links"
                id="meeting_unitTest"
                data-qe-id="forum-tool-kit_launch_btn"
                @click="intialToolKit()">
                <i class="fas fa-toolbox"></i>
                <v-flex tag="strong">{{toolKitConstants.FORUM_TOOLKIT}}</v-flex>
            </v-flex>
            <v-dialog
                v-model="toolkitDialog"
                scrollable
                content-class="large"
                persistent>
                <v-card class="meetings-popup forum-dialog">
                    <v-card-title>
                        {{toolKitConstants.FORUM_TOOLKIT}}
                        <v-flex class="meetings-popup__close">
                            <v-btn
                                flat
                                icon
                                @click="closeDialog()"
                                id="close_unitTest"
                                data-qe-id="close_dialog_btn">
                                <v-icon>close</v-icon>
                            </v-btn>
                        </v-flex>
                    </v-card-title>
                    <v-card-text
                        class="inner-scrollbar toolkit-block"
                        id="toolKitVcard"
                        ref="forumToolkit">
                        <v-layout row wrap>
                            <v-flex md4>
                                <v-flex
                                    class="toolkit-block__items"
                                    v-for="(tool,i) in forumToolKitList"
                                    :key="i"
                                    :class="tool.name === selectedType ? 'toolkit-block__items__active' : ''">
                                    <v-flex @click="toolKitContent(tool.name)" :data-qe-id="`forum-tool-kit_item-${i}`">
                                        <img :src="tool.img">
                                        <strong :data-qe-id="`forum-tool-kit_item-${i}_name`">{{tool.name}}</strong>
                                        <small>{{tool.tag}}</small>
                                    </v-flex>
                                </v-flex>
                            </v-flex>
                            <v-flex md8 class="toolkit-block__details">
                                <v-layout row wrap>
                                    <v-flex
                                        md11
                                        row
                                        wrap
                                        align-center
                                        justify-space-between
                                        v-if="!isShowThirdSection"
                                        class="toolkit-block__details--header">
                                        <v-flex tag="h1">{{TitleHeader}} </v-flex>
                                        <div class="toolkit-search-scope">
                                            <v-text-field
                                                :label="ForumLinkTexts.SEARCH"
                                                append-icon="search"
                                                slot="activator"
                                                single-line
                                                small
                                                outline
                                                clearable
                                                class="toolkit-block__search-input"
                                                v-model="forumSearchText"
                                                data-qe-id="forum-tool-kit_search_input"
                                                @keyup="getForumSearch(forumSearchText)"
                                                @click:clear="clearForumSearch()">
                                            </v-text-field>
                                        </div>
                                    </v-flex>
                                    <v-flex
                                        md1
                                        row
                                        wrap
                                        class="toolkit-filter__icon"
                                        v-if="!isShowThirdSection"
                                        data-qe-id="forum-tool-kit_pop-up_filter_btn"
                                        :class="filterNotExists ? 'toolkit-filter__icon-large' : ''"
                                        @click="popupFilter()">
                                        <span v-if="filterNotExists"><i class="fas fa-filter fa-lg"></i></span>
                                        <span v-else><i class="fas fa-filter"></i></span>
                                    </v-flex>
                                    <transition name="fade" mode="in-out">
                                        <v-flex v-if='toolkitFilterDialog' class="custom-popover toolkit-filter__popup-margin">
                                            <v-flex class="custom-popover__cont">
                                                <v-card>
                                                    <v-card-title class="toolkit-filter__title">
                                                        {{toolKitConstants.FILTER}}
                                                    </v-card-title>
                                                    <v-divider></v-divider>
                                                    <v-card-text>
                                                        <v-layout
                                                            md12
                                                            row
                                                            wrap
                                                            class="toolkit-filter__range-slider">
                                                            <v-flex md5 class="toolkit-filter__font-weight toolkit-filter__padding-top20">
                                                                {{toolKitConstants.TIME_LENGTH}}
                                                            </v-flex>
                                                            <v-flex md6>
                                                                <v-range-slider
                                                                    v-model="range"
                                                                    :max="toolKitConstants.MAX_RANGE"
                                                                    :min="toolKitConstants.MIN_RANGE"
                                                                    :step="toolKitConstants.STEP_RANGE">
                                                                </v-range-slider>
                                                            </v-flex>
                                                        </v-layout>
                                                        <v-layout md12>
                                                            <v-flex md5></v-flex>
                                                            <v-flex md6 class="toolkit-filter__margin-minus">
                                                                <span class="toolkit-filter">{{timeConverter(range[0])}}</span>
                                                                <span class="toolkit-filter__padding-top toolkit-filter__padding-left100">
                                                                    {{timeConverter(range[1])}}
                                                                </span>
                                                            </v-flex>
                                                        </v-layout>
                                                        <v-layout md12 class="toolkit-filter__type-filter">
                                                            <v-flex md5 class="toolkit-filter__font-weight">{{toolKitConstants.TOPIC}}</v-flex>
                                                            <v-flex md6>
                                                                <v-autocomplete
                                                                    attach
                                                                    v-model="topicSelected"
                                                                    data-qe-id="forum_topic_filter"
                                                                    color="ypo_blue"
                                                                    :items="filterTopicsList"
                                                                    item-text='topic'
                                                                    item-value='topic'>
                                                                </v-autocomplete>
                                                            </v-flex>
                                                        </v-layout>
                                                        <v-layout
                                                            row
                                                            wrap
                                                            class="toolkit-filter__materials">
                                                            <v-flex md9 xs7>{{toolKitConstants.RECENTLY_ADDED}}</v-flex>
                                                            <v-switch
                                                                md3
                                                                class="toolkit-filter__switch-padding"
                                                                v-model="isRequiredRecentlyAdded"
                                                                color="ypo_blue"
                                                                data-qe-id="forum-tool-kit_filter_needs-material_switch_btn"
                                                                value="ypo_blue"
                                                                hide-details></v-switch>
                                                        </v-layout>
                                                        <v-layout
                                                            row
                                                            wrap
                                                            class="toolkit-filter__materials">
                                                            <v-flex md9 xs7>{{toolKitConstants.NEED_MATERIALS}}</v-flex>
                                                            <v-switch
                                                                md3
                                                                class="toolkit-filter__switch-padding"
                                                                v-model="switchModel"
                                                                color="ypo_blue"
                                                                data-qe-id="forum-tool-kit_filter_needs-material_switch_btn"
                                                                value="ypo_blue"
                                                                hide-details></v-switch>
                                                        </v-layout>
                                                    </v-card-text>
                                                    <v-divider class="mt-3"></v-divider>
                                                    <v-card-actions>
                                                        <v-layout justify-end pr-3>
                                                            <v-btn
                                                                flat
                                                                @click="clearFilterDialog()"
                                                                id="clearFilter_unitTest"
                                                                data-qe-id="forum-tool-kit_filter_clear_btn">
                                                                {{toolKitConstants.CLEAR}}
                                                            </v-btn>
                                                            <v-btn
                                                                @click="applyFilter(true)"
                                                                data-qe-id="forum-tool-kit_filter_apply_btn"
                                                                color="primary"
                                                                :disabled="!filterExists">
                                                                {{toolKitConstants.APPLY}}
                                                            </v-btn>
                                                        </v-layout>
                                                    </v-card-actions>
                                                </v-card>
                                            </v-flex>
                                            <v-flex class="custom-popover__bg" @click='toolkitFilterDialog= !toolkitFilterDialog'></v-flex>
                                        </v-flex>
                                    </transition>
                                    <v-layout class="sample-agendas" v-if="!isShowThirdSection">
                                        <v-flex
                                            justify-space-around
                                            row
                                            wrap
                                            v-if="toolkitList.length">
                                            <v-flex
                                                class="toolkit-block__details__first-container"
                                                v-for="(item,i) in toolkitList"
                                                :key="i"
                                                :class="item.id === selectedExerciseType ? 'toolkit-block__items__active' : ''">
                                                <v-layout
                                                    row
                                                    wrap
                                                    class="toolkit-block__content">
                                                    <v-flex
                                                        column
                                                        xs12
                                                        sm9
                                                        class="toolkit-block__content--row"
                                                        :data-qe-id="`forum-tool-kit_exercise-${i}_link`"
                                                        :id="`forum_toolKit_unitTest_${i}`"
                                                        @click="getExercise(item.id)">
                                                        <v-flex
                                                            tag="strong"
                                                            class="toolkit-block__content--title"
                                                            :data-qe-id="`forum-tool-kit_exercise-${i}_title`"
                                                            :class="{'shortDescription' : isShowThirdSection}">
                                                            <img v-if="selectedType === toolKitConstants.ALL_TOOLKIT_CONTENT" :src="getTypesIcon(item.type)">
                                                            {{item.title}}
                                                        </v-flex>
                                                        <v-flex
                                                            class="toolkit-block__content--description"
                                                            :data-qe-id="`forum-tool-kit_exercise-${i}_description`"
                                                            :class="{'shortDescription' : isShowThirdSection}">
                                                            {{item.description}}
                                                        </v-flex>
                                                    </v-flex>
                                                    <v-flex
                                                        xs12
                                                        sm3
                                                        class="toolkit-block__content--duration"
                                                        v-if="item.duration > 0">
                                                        <i class="far fa-clock"></i>
                                                        <small :data-qe-id="`forum-tool-kit_exercise-${i}_duration`">
                                                            {{timeConverter(item.duration)}}
                                                        </small>
                                                    </v-flex>
                                                </v-layout>
                                            </v-flex>
                                        </v-flex>
                                        <v-flex
                                            v-else
                                            tag="strong"
                                            data-qe-id="no_data_available"
                                            class="toolkit-block__content--nodata">
                                            {{toolKitConstants.NO_DATA_AVAILABLE}}
                                        </v-flex>
                                    </v-layout>
                                    <v-layout
                                        class="toolkit-block__details--last-container"
                                        v-if="isShowThirdSection"
                                        md6>
                                        <v-flex
                                            v-if="isShowThirdSection"
                                            @click="backToExcersice()"
                                            class="back_icon">
                                            <i class="fas fa-chevron-left"></i> Back
                                        </v-flex>
                                        <v-flex>
                                            <v-layout row wrap>
                                                <v-flex xs6 data-qe-id="forum-tool-kit_selected-exercise_type">
                                                    <img :src="getTypesIcon(thirdSectionData.type)">
                                                    <small> {{thirdSectionData.type}}</small>
                                                </v-flex>
                                                <v-flex xs6 text-right data-qe-id="forum-tool-kit_selected-exercise_link" class="exercise_link" v-if="!isMobileAppBrowser" @click="copyToClipboard">
                                                    <small> <i class="fa fa-link" aria-hidden="true"></i> {{toolKitConstants.COPY_CLIPBOARD}} </small>
                                                </v-flex>
                                                <v-flex class="hidden-overlay">
                                                    <input :id= toolKitConstants.EXERCISE_URL :value="exerciseUrl"/>
                                                </v-flex>
                                            </v-layout>
                                            <v-flex tag="h1" data-qe-id="forum-tool-kit_selected-exercise_title">
                                                <span> {{thirdSectionData.title}}</span>
                                            </v-flex>
                                            <v-flex tag="p" data-qe-id="forum-tool-kit_selected-exercise_description">
                                                {{thirdSectionData.description}}
                                            </v-flex>
                                            <v-flex tag="p" data-qe-id="forum-tool-kit_selected-exercise_instructions">
                                                <span v-html="thirdSectionData.instructions"></span>
                                            </v-flex>
                                            <v-flex tag="p" data-qe-id="forum-tool-kit_selected-exercise_tips">
                                                <span v-html="thirdSectionData.tips"></span>
                                            </v-flex>
                                            <v-flex data-qe-id="forum-tool-kit_selected-author" class="contributed-author" v-if="thirdSectionData.author">
                                                <span>{{ForumLinkTexts.CONTRIBUTED_BY}} {{thirdSectionData.author}}</span>
                                            </v-flex>
                                        </v-flex>
                                    </v-layout>
                                </v-layout>
                            </v-flex>
                        </v-layout>
                        <BackToTopForDialog refId="toolKitVcard"></BackToTopForDialog>
                    </v-card-text>
                </v-card>
            </v-dialog>
        </v-flex>
    </v-layout>
</template>

<script>
    import { mapState, mapActions, mapGetters, mapMutations } from 'vuex';
    import { toolKitConstants } from '../ChapterPage/communityCommon.constant';
    import { storeAction } from '../../store/storeActions.constant';
    import { storeGetters } from '../../store/storeGetters.constant';
    import { storeMutation } from '../../store/storeMutations.constant';
    import { appCommonConstants, routerNames } from "../appCommon.constants";
    import { ForumLinkTexts } from "../ForumPage/ForumConstants";
    import StatusOverlay from '@/components/StatusOverlay/StatusOverlay';
    import orderBy from "lodash/orderBy";
    import uniqBy from 'lodash/uniqBy';
    import BackToTopForDialog from "../ScrollTo/BackToTopForDialog";

    export default {
        name: "ForumToolKit",
        components: {
            StatusOverlay,
            BackToTopForDialog,
        },
        created() {
            if (this.$route && this.$route.name === this.routerNames.FORUM_EXERCISE) {
                this.toolkitDialog = true;
                    if (this.$route && this.$route.params && this.$route.params.type) {
                        this.toolkitDialog = true;
                        this.getForumToolKit();
                        this.getForumToolKitListContent().then(() => {
                            this.toolKitContent(this.$route.params.type);
                            if (this.$route.query.content) {
                                this.getExercise(this.$route.query.content);
                            }
                        });
                    } else {
                        this.toolKitContent(this.forumToolKitList[0].name);
                    }
                } else {
                this.getForumToolKit();
                this.getForumToolKitListContent()
                    .then(() => {
                        if (this.forumToolKitList && this.forumToolKitList.length) {
                            this.toolKitContent(this.forumToolKitList[0].name);
                        }
                    });
            }
        },
        data: () => {
            return {
                ForumLinkTexts,
                toolkitDialog: false,
                toolkitList: [],
                toolkitListOrigin: [],
                TitleHeader: '',
                toolKitConstants,
                appCommonConstants,
                isShowThirdSection: false,
                thirdSectionData: {
                    type: '',
                    title: '',
                    description: '',
                    instructions: '',
                    tips: '',
                    category1: '',
                    author: '',
                },
                forumSearchText: '',
                toolkitFilterDialog: false,
                range: [toolKitConstants.MIN_RANGE, toolKitConstants.MAX_RANGE],
                switchModel: '',
                panel: [],
                filterTopicsList: [],
                topicSelected: 'All',
                panelValue: 0,
                selectedType: '',
                isRequiredRecentlyAdded: false,
                selectedExerciseType: '',
                backToScrollPosition: '',
                baseUrl: null,
                exerciseUrl: null,
                routerNames,
            };
        },
        methods: {
            ...mapActions({
                getForumToolKit: `forum/${storeAction.getForumToolKitList}`,
                getForumToolKitListContent: `forum/${storeAction.getForumToolKitListContent}`,
                getForumToolKitExercises: `forum/${storeAction.getForumToolKitExercises}`,
            }),
            ...mapMutations({
                setListState: `forum/${storeMutation.setListState}`,
                setAllListState: `forum/${storeMutation.setAllListState}`,
            }),
            closeDialog() {
                this.toolkitDialog = false;
                this.scrollTop();
                this.setAllListState();
                if (this.$route.name === this.routerNames.FORUM_EXERCISE) {
                    this.$router.go(-1);
                }
            },
            intialToolKit() {
                this.toolkitDialog = true;
            },
            copyToClipboard() {
                const exerciseElement = document.getElementById(this.toolKitConstants.EXERCISE_URL);
                exerciseElement.select();
                document.execCommand("copy");
            },
            toolKitContent(value) {
                value = value.replaceAll('%20', ' ');
                this.clearFilterDialog();
                this.selectedExerciseType = '';
                this.TitleHeader = value;
                this.isShowThirdSection = false;
                this.forumSearchText = '';
                this.allToolkitContent(value);
                this.selectedType = value;
                this.getFilterObject();
                if (this.filterNotExists) {
                    this.popupFilter();
                    this.applyFilter();
                }
                this.createBaseUrl(value);
                return this.toolkitList;
            },
            timeConverter(value) {
                const num = value;
                const hours = (num / 60);
                const rhours = Math.floor(hours);
                const minutes = (hours - rhours) * 60;
                const rminutes = Math.round(minutes);
                if (rhours === 0) {
                    return `${rminutes} mins`;
                } else if (rminutes === 0) {
                    return `${rhours} hr`;
                }
                return `${rhours} hr ${rminutes} mins`;
            },
            thirdSection(secondSection) {
                this.isShowThirdSection = true;
                this.thirdSectionData.type = secondSection.type;
                this.thirdSectionData.title = secondSection.title;
                this.thirdSectionData.description = secondSection.description;
                this.thirdSectionData.instructions = secondSection.instructions;
                this.thirdSectionData.tips = secondSection.tips;
                this.thirdSectionData.category1 = secondSection.category1;
                this.thirdSectionData.author = secondSection.author;
            },
            getExercise(id) {
                this.selectedExerciseType = id;
                this.getForumToolKitExercises(id)
                    .then((response) => {
                        this.thirdSection(response.data);
                        this.scrollTop();
                        this.addContentToBaseUrl(id);
                    });
            },
            createBaseUrl(title) {
                this.baseUrl = null;
                if (title) {
                    const baseUrl = window.location.origin;
                    title = title.replaceAll(' ', '%20');
                    this.baseUrl = `${baseUrl}/#/forum/exercise/${title}?`;
                }
            },
            addContentToBaseUrl(id) {
                if (id) {
                    this.exerciseUrl = '';
                    this.exerciseUrl = `${this.baseUrl}content=${id}`;
                }
            },
            clearForumSearch() {
                this.forumSearchText = "";
                this.applyFilter();
            },
            getForumSearch() {
                this.applyFilter();
            },
            clearFilterDialog() {
                this.topicSelected = 'All';
                this.range = [toolKitConstants.MIN_RANGE, toolKitConstants.MAX_RANGE];
                this.switchModel = '';
                this.isRequiredRecentlyAdded = false;
                this.allToolkitContent(this.selectedType);
                this.getFilterTopicsList();
                this.setListState({
                    name: this.selectedType,
                    timeRange: this.range,
                    topic: this.topicSelected,
                    materials: this.switchModel,
                    isRequiredRecentlyAdded: this.isRequiredRecentlyAdded,
                });
            },
            applyFilter(user) {
                if (user) {
                    this.toolkitFilterDialog = false;
                }
                this.allToolkitContent(this.selectedType);
                if (this.forumSearchText && this.forumSearchText.length > 2) {
                    this.isShowThirdSection = false;
                    this.toolkitList = this.toolkitList.filter(tool => tool.title.toLowerCase().includes(this.forumSearchText.toLowerCase()));
                }
                const item = this.filterTopicsList ? this.filterTopicsList.find(f => f.topic === this.topicSelected) : null;
                if (item && this.topicSelected !== 'All') {
                    this.toolkitList = this.toolkitList.filter(k => (k.type === item.type || this.selectedType === toolKitConstants.ALL_TOOLKIT_CONTENT) &&
                        (k.categoryNames.includes(item.topic)));
                }
                this.toolkitList = this.switchModel ? this.toolkitList.filter(l => !l.materials) : this.toolkitList;
                if (!(this.range[0] === toolKitConstants.MIN_RANGE && this.range[1] === toolKitConstants.MAX_RANGE)) {
                    this.toolkitList = this.toolkitList.filter(l => l.duration >= this.range[0] && l.duration <= this.range[1]);
                }
                if (this.isRequiredRecentlyAdded) {
                    this.toolkitList = orderBy(this.toolkitList, ['createdDate', 'duration', 'title'], ['desc', 'desc', 'asc']);
                }
                if (!this.toolkitList.some(x => x.id === this.selectedExerciseType)) {
                    this.isShowThirdSection = false;
                }
                this.setListState({
                    name: this.selectedType,
                    timeRange: this.range,
                    topic: this.topicSelected,
                    materials: this.switchModel,
                    isRequiredRecentlyAdded: this.isRequiredRecentlyAdded,
                });
            },
            allToolkitContent(value) {
                if (value === toolKitConstants.ALL_TOOLKIT_CONTENT) {
                    this.toolkitList = this.forumToolKitListContent;
                } else {
                    this.toolkitList = this.forumToolKitListContent.filter(item => item.type === value);
                }
            },
            getFilterTopicsList() {
                let topicsList = [];
                this.toolkitList.forEach((content) => {
                    topicsList.push({ type: content.type, title: content.title, topic: content.categoryNames[0] });
                    topicsList.push({ type: content.type, title: content.title, topic: content.categoryNames[1] });
                    topicsList.push({ type: content.type, title: content.title, topic: content.categoryNames[2] });
                    topicsList.push({ type: content.type, title: content.title, topic: content.categoryNames[3] });
                    topicsList.push({ type: content.type, title: content.title, topic: content.categoryNames[4] });
                    topicsList.push({ type: content.type, title: content.title, topic: content.categoryNames[5] });
                });
                topicsList = uniqBy(topicsList, 'topic').filter(f => !!f.topic);
                topicsList = orderBy(topicsList, 'topic');
                this.filterTopicsList = [];
                this.filterTopicsList.push({ topic: 'All' });
                this.filterTopicsList.push(...topicsList);
            },
            popupFilter() {
                this.toolkitFilterDialog = true;
                this.getFilterTopicsList();
            },
            getFilterObject() {
                const filter = this.forumObjectState ? this.forumObjectState.find(t => t.name === this.selectedType) : null;
                if (filter) {
                    this.topicSelected = filter.topic;
                    this.range = filter.timeRange;
                    this.switchModel = filter.materials;
                    this.isRequiredRecentlyAdded = filter.isRequiredRecentlyAdded;
                }
            },
            scrollTop() {
                if (this.$refs.forumToolkit) {
                    this.backToScrollPosition = this.$refs.forumToolkit.scrollTop;
                    this.$refs.forumToolkit.scrollTop = 0;
                }
            },
            getTypesIcon(type) {
                return this.forumToolKitList.find(x => x.name === type).img;
            },
            backToExcersice() {
                this.isShowThirdSection = false;
                if (this.$refs.forumToolkit) {
                    setTimeout(() => {
                        this.$refs.forumToolkit.scrollTop = this.backToScrollPosition;
                    }, 50);
                }
            },
        },
        computed: {
            ...mapState('actionState', ['actions']),
            ...mapGetters({
                forumToolKitList: `forum/${storeGetters.forumToolKitList}`,
                forumToolKitListContent: `forum/${storeGetters.forumToolKitListContent}`,
                forumToolKitListExercise: `forum/${storeGetters.forumToolKitListExercise}`,
                usersCommunitiesList: `chapter/${storeGetters.usersCommunitiesList}`,
                forumObjectState: `forum/${storeGetters.forumObjectState}`,
                isMobileAppBrowser: `${[storeGetters.isMobileAppBrowser]}`,
            }),
            loadAction() {
                return this.actions[storeAction.getForumToolKitList];
            },
            filterExists() {
                return !!(this.isTopicChanged === true || this.range[0] !== toolKitConstants.MIN_RANGE ||
                    this.range[1] !== toolKitConstants.MAX_RANGE || this.selectedTypeObject.materials !== this.switchModel || this.selectedTypeObject.isRequiredRecentlyAdded !== this.isRequiredRecentlyAdded);
            },
            filterNotExists() {
                return !!(this.isTopicChanged === true || this.range[0] !== toolKitConstants.MIN_RANGE ||
                    this.range[1] !== toolKitConstants.MAX_RANGE || this.switchModel || this.isRequiredRecentlyAdded);
            },
            isTopicChanged() {
                const filter = this.forumObjectState ? this.forumObjectState.find(t => t.name === this.selectedType) : null;
                return filter && filter.topic !== this.topicSelected;
            },
            selectedTypeObject() {
                return (this.forumObjectState && this.forumObjectState.find(t => t.name === this.selectedType)) || {};
            },
        },
    };
</script>

<style lang="scss" scoped>
    @import "../../common/styles/_colors.scss";
    @import "../../common/styles/_responsive.scss";

    .meeting-tools {
        &__links {
            cursor: pointer;
            text-align: center;
            width: auto;
            display: block;
            color: $ypo-dark-background-gray;
            padding: 30px 30px;
            transition: 0.3s;
            margin: 0 auto;
            max-width: initial;

            &:hover {
                color: $ypo_blue;
            }

            i {
                display: block;
                font-size: 36px;
            }

            strong {
                font-weight: 500;
                margin-top: 5px;
                display: block;
            }
        }
    }

    .meetings-popup {
        background: $white;

        .v-card__text {
            padding: 0px;
        }

        &__close {
            position: relative;

            .v-btn {
                position: absolute;
                right: -5px;
                z-index: 1;
                top: -20px;
            }
        }

        &__moreitems {
            position: relative;

            &:before {
                content: "";
                height: 100%;
                position: absolute;
                border-left: 1px dashed $ypo-dark-background-gray;
                left: 23px;
            }
        }

        .v-card__title {
            border-radius: 4px 4px 0 0;
            background-color: rgba($ypo_blue, 0.15);
            padding: 15px 10px 15px 50px;
            font-weight: 300;
            font-size: 24px;
            margin-bottom: 20px;
            color: $ypo_blue;
        }

        .date {
            color: $ypo-gold;
            font-size: 16px;
            font-weight: bold;
            line-height: 22px;
            padding: 0px 0 10px 15px;

            i {
                font-size: 20px;
                color: $ypo_blue;
                margin-right: 10px;
                background: $white;
                position: relative;
                z-index: 1;
            }
        }

        .desc {
            position: relative;
            padding: 15px 10px 15px 60px;
            cursor: pointer;
            margin-bottom: 20px;
            transition: all 0.4s ease;

            &:after {
                content: "";
                width: 90%;
                left: 7%;
                bottom: 0;
                height: 2px;
                background: rgba($ypo-blue-secondary, 0.05);
                position: absolute;
            }

            &+.desc {
                margin-top: -20px;
            }

            strong {
                color: $ypo_blue;
                font-size: 16px;
                font-weight: bold;
                line-height: 22px;
                display: block;
                margin-bottom: 10px;
            }

            span {
                color: $black;
                font-family: "Noto Sans";
                font-size: 12px;
                letter-spacing: -0.15px;
                line-height: 22px;
                border-right: 1px solid $ypo-medium-gray;
                padding-right: 15px;
                margin-right: 15px;

                i {
                    color: $ypo-dark-background-gray;
                    margin-right: 5px;
                }
            }

            small {
                color: rgba($black, 0.5);
                font-size: 12px;
                letter-spacing: -0.15px;
                line-height: 22px;

                i {
                    color: $ypo-dark-background-gray;
                    margin-right: 5px;
                }
            }

            .more-info {
                position: absolute;
                right: 10px;
                top: 25px;
                text-align: center;
                color: $ypo-dark-background-gray;
                padding: 0 20px;
                transition: all 0.2s ease;

                i {
                    display: block;
                }

                small {
                    color: $ypo-dark-background-gray;
                    text-transform: uppercase;
                    font-size: 10px;
                }
            }

            &:hover {
                background: rgba($ypo-blue-secondary, 0.05);

                .more-info {
                    opacity: 0;
                    visibility: hidden;
                }

                .desc__actions {
                    opacity: 1;
                    visibility: visible;
                }
            }

            &__actions {
                position: absolute;
                right: 20px;
                top: 25px;
                z-index: 1;
                opacity: 0;
                visibility: hidden;
                transition: all 0.6s ease;

                em {
                    color: $ypo-gray-text;
                    font-size: 10px;
                    font-style: normal;
                    line-height: 14px;
                    text-align: center;
                    display: inline-block;
                    margin: 0 10px;
                    cursor: pointer;

                    i {
                        display: block;
                        font-size: 19px;

                        &.fa-share {
                            color: $ypo-blue-secondary;
                        }

                        &.fa-times-circle {
                            color: $ypo-red;
                        }
                    }
                }
            }
        }
    }

    .meetings-popup {
        background: $white;

        .v-card__text {
            padding: 0px;
        }

        &__moreitems {
            position: relative;

            &:before {
                content: "";
                height: 100%;
                position: absolute;
                border-left: 1px dashed $ypo-dark-background-gray;
                left: 23px;
            }
        }

        .v-card__title {
            border-radius: 4px 4px 0 0;
            background-color: rgba($ypo_blue, 0.15);
            padding: 15px 10px 15px 50px;
            font-weight: 300;
            font-size: 24px;
            margin-bottom: 20px;
            color: $ypo_blue;
        }

        .date {
            color: $ypo-gold;
            font-size: 16px;
            font-weight: bold;
            line-height: 22px;
            padding: 0px 0 10px 15px;

            i {
                font-size: 20px;
                color: $ypo_blue;
                margin-right: 10px;
                background: $white;
                position: relative;
                z-index: 1;
            }
        }

        .desc {
            position: relative;
            padding: 15px 10px 15px 60px;
            cursor: pointer;
            margin-bottom: 20px;
            transition: all 0.4s ease;

            &:after {
                content: "";
                width: 90%;
                left: 7%;
                bottom: 0;
                height: 2px;
                background: rgba($ypo-blue-secondary, 0.05);
                position: absolute;
            }

            &+.desc {
                margin-top: -20px;
            }

            strong {
                color: $ypo_blue;
                font-size: 16px;
                font-weight: bold;
                line-height: 22px;
                display: block;
                margin-bottom: 10px;
            }

            span {
                color: $black;
                font-family: "Noto Sans";
                font-size: 12px;
                letter-spacing: -0.15px;
                line-height: 22px;
                border-right: 1px solid $ypo-medium-gray;
                padding-right: 15px;
                margin-right: 15px;

                i {
                    color: $ypo-dark-background-gray;
                    margin-right: 5px;
                }
            }

            small {
                color: rgba($black, 0.5);
                font-size: 12px;
                letter-spacing: -0.15px;
                line-height: 22px;

                i {
                    color: $ypo-dark-background-gray;
                    margin-right: 5px;
                }
            }

            .more-info {
                position: absolute;
                right: 10px;
                top: 25px;
                text-align: center;
                color: $ypo-dark-background-gray;
                padding: 0 20px;
                transition: all 0.2s ease;

                i {
                    display: block;
                }

                small {
                    color: $ypo-dark-background-gray;
                    text-transform: uppercase;
                    font-size: 10px;
                }
            }

            &:hover {
                background: rgba($ypo-blue-secondary, 0.05);

                .more-info {
                    opacity: 0;
                    visibility: hidden;
                }

                .desc__actions {
                    opacity: 1;
                    visibility: visible;
                }
            }

            &__actions {
                position: absolute;
                right: 20px;
                top: 25px;
                z-index: 1;
                opacity: 0;
                visibility: hidden;
                transition: all 0.6s ease;

                em {
                    color: $ypo-gray-text;
                    font-size: 10px;
                    font-style: normal;
                    line-height: 14px;
                    text-align: center;
                    display: inline-block;
                    margin: 0 10px;
                    cursor: pointer;

                    i {
                        display: block;
                        font-size: 19px;

                        &.fa-share {
                            color: $ypo-blue-secondary;
                        }

                        &.fa-times-circle {
                            color: $ypo-red;
                        }
                    }
                }
            }
        }

        .toolkit-block__details {

            .back_icon {
                max-width: inherit !important;
                color: $ypo_cta;
                margin: 10px;
                font-size: 16px;
                cursor: pointer;
                min-width: 80px;
            }

            &--header {
                border-bottom: 1px solid rgba(131, 151, 167, 0.2);
                min-height: 82px !important;

                h1 {
                    padding: 30px 20px 20px 20px;
                    float: left;
                    width: 55%;

                    @include breakpoint(xs) {
                        width: 100%;
                        float: none;
                        text-overflow: ellipsis;
                        overflow: hidden;
                        white-space: nowrap;
                    }
                }

                &-width {
                    min-width: 100%;
                }
            }

            .toolkit-search {
                padding-top: 16px;

                .v-text-field {
                    display: inline-block;
                    width: 90%;
                }
            }

            @include breakpoint(sm) {
                .toolkit-filter__icon-large {
                    padding-bottom: 10px !important;
                }
            }
        }
    }

    .sample-agendas {
        padding: 0 !important;

        &:hover {
            background: none !important;
        }

        .toolkit-block__items {
            padding-left: 50px;
            padding-right: 70px;

            i.fa-clock {
                top: 2px;
                left: 0;
            }

            i {
                top: 18px;
            }
        }

        &__middle-panel {
            border-right: 1px solid rgba(131, 151, 167, 0.2);
        }

        .time {
            right: 15px;
            top: 18px;

            i {
                color: $ypo-dark-background-gray !important;
                font-size: 13px;
            }

            small {
                font-size: 12px;
                color: $ypo-dark-background-gray !important;
                font-weight: 500;
                padding-left: 22px;
            }
        }

    }

    .thirdSection {
        width: 50%;
    }

    .shortDescription {
        text-overflow: clip;
        white-space: normal !important;
        overflow: hidden;
    }

    .toolkit-block {
        margin-top: -20px;

        &__items {
            color: $ypo_blue;
            font-size: 16px;
            font-weight: bold;
            cursor: pointer;
            line-height: 32px;
            position: relative;
            transition: 0.3s ease all;
            padding: 15px 0 15px 60px;
            border-bottom: 1px solid rgba($ypo-dark-background-gray, 0.2);
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;

            &:hover {
                background: rgba($ypo-dark-background-gray, 0.2);
            }

            &__active {
                background: rgba($ypo-dark-background-gray, 0.2);
            }

            i {
                position: absolute;
                left: 20px;
                top: 30px;
                color: $ypo-cta !important;
                font-size: 16px;
            }

            small {
                display: block;
                color: $ypo-cta;
                font-size: 12px;
                letter-spacing: -0.1px;
                line-height: 20px;
            }

            img {
                position: absolute;
                top: 30px;
                left: 21px;
                height: 20px;
            }
        }

        &__search-input {
            background-color: $white;
            max-width: 322px;
            padding-top: 16px;

            @include breakpoint(xs) {
                max-width: 270px;
                padding: 0 0px 0 20px;
            }
        }

        &__content {
            padding: 20px 10px;
            border-bottom: 1px solid rgba($ypo-dark-background-gray, 0.2);

            &--row {
                overflow: hidden;
                text-overflow: ellipsis;
            }

            &--title {
                color: $ypo_blue;
                font-size: 16px;
                font-weight: bold;
                cursor: pointer;
                line-height: 22px;
                text-overflow: ellipsis;
                white-space: nowrap;
                overflow: hidden;

                img {
                    height: 20px;
                    position: relative;
                    top: 3px;
                }
            }

            &--description {
                display: block;
                color: $ypo-cta;
                font-size: 14px;
                line-height: 20px;
                text-overflow: ellipsis;
                white-space: nowrap;
                overflow: hidden;
                cursor: pointer;
            }

            &--duration {
                color: $ypo-dark-background-gray;
                font-size: 14px;
                line-height: 20px;

                i {
                    margin-right: 7px;
                }
            }

            &--nodata {
                text-align: center;
                margin-top: 50px;
                color: $ypo_blue;
                font-size: 16px;
            }
        }

        &__details {
            border-left: 1px solid rgba($ypo-dark-background-gray, 0.2);

            .details {
                transition: 0.3s all ease;
                padding: 10px 0 10px 20px;
                align-items: center;

                h3 {
                    color: $ypo_blue;
                    font-size: 18px;
                    font-weight: bold;
                    line-height: 24px;
                    margin-bottom: 3px;
                }

                p {
                    color: $ypo-dark-gray;
                    font-family: "Noto Sans";
                    font-size: 14px;
                    letter-spacing: 0.1px;
                    line-height: 18px;
                    margin-bottom: 0;
                }

                .time {
                    color: $ypo-dark-background-gray;
                    font-size: 14px;
                    line-height: 20px;

                    i {
                        margin-right: 7px;
                    }
                }

                &:hover {
                    background: rgba($ypo-dark-background-gray, 0.2);
                }
            }

            &--last-container {
                border-left: 1px solid rgba($ypo-dark-background-gray, 0.2);
                padding-left: 15px;
                padding-right: 15px;
                width: 50%;

                img {
                    position: relative;
                    top: 4px;
                    height: 20px;
                }

                small {
                    color: $ypo-cta;
                    font-size: 12px;
                    line-height: 40px;
                }

                .exercise_link {
                    display: block;
                    small {
                        cursor: pointer;
                        font-weight: 600;
                    }
                    @include breakpoint(sm) {
                        display: none;
                    }
                }

                .contributed-author {
                    font-weight: 600;
                }
            }
        }

        h1 {
            color: $ypo_blue;
            font-family: 'Noto Sans', sans-serif;
            font-size: 20px;
            font-weight: bold;
            line-height: 26px;
        }
    }

    .popover__title {
        font-size: 24px;
        line-height: 36px;
        text-decoration: none;
        color: rgb(228, 68, 68);
        text-align: center;
        padding: 15px 0;
    }

    .popover__wrapper {
        position: relative;
        margin-top: 1.5rem;
        display: inline-block;
    }

    .popover__content {
        opacity: 0;
        visibility: hidden;
        position: absolute;
        left: -280px;
        transform: translate(0, 10px);
        background-color: #bfbfbf;
        padding: 1.5rem;
        box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.26);
        width: auto;
    }

    .popover__content:before {
        position: absolute;
        z-index: -1;
        content: "";
        right: calc(50% - 10px);
        top: -8px;
        border-style: solid;
        border-width: 0 10px 10px 10px;
        border-color: transparent transparent #bfbfbf transparent;
        transition-duration: 0.3s;
        transition-property: transform;
    }

    .popover__wrapper:hover .popover__content {
        z-index: 10;
        opacity: 1;
        visibility: visible;
        transform: translate(0, -20px);
        transition: all 0.5s cubic-bezier(0.75, -0.02, 0.2, 0.97);
    }

    .popover__message {
        text-align: center;
    }

    .toolkit-filter {
        &__icon {
            margin: auto;
            cursor: pointer;
            text-align: center;
            color: $ypo-cta !important;
            border-bottom: 1px solid $ypo-light-gray;
            margin-bottom: 0;
            vertical-align: middle;
            padding-bottom: 30px;

            @include breakpoint(xs) {
                padding-bottom: 23px;
                align-self: flex-end;
            }
        }

        &__title {
            margin: auto;
            font-size: 20px;
            font-weight: 600;
            padding-left: 200px !important;

            @include breakpoint(xs) {
                padding-left: 20px !important;
            }
        }

        &__materials {
            background-color: $ypo-extra-light-gray;
            height: 50px;
            padding-top: 16px;
            font-weight: 600;
            margin-top: 10px;
            padding-left: 10px;
            min-width: 450px !important;

            &:nth-child(2n + 1) {
                background-color: $white;
            }

            @include breakpoint(xs) {
                min-width: inherit !important;
            }
        }

        &__top-margin {
            margin-top: 10px;
        }

        &__font-weight {
            font-weight: 600;
            padding: 10px;
        }

        &__range-slider {
            background-color: $ypo-extra-light-gray;

            @include breakpoint(xs) {
                padding: 0 20px;
            }
        }

        &__popup-margin {
            margin-top: 60px;
            max-width: 500px;

            @include breakpoint(xs) {
                margin: auto;
                max-width: inherit;
                min-width: auto;
                left: 0;
                width: 80% !important;
            }
        }

        &__transition-padding {
            padding-left: 10px !important;
            padding-bottom: 5px !important;
        }

        &__switch-padding {
            padding-left: 20px;
        }

        &__padding-top20 {
            padding-top: 20px;
        }

        &__lower {
            text-transform: lowercase;
        }

        &__margin-minus {
            margin-top: -30px;
            justify-content: space-between;
            display: flex;

            @include breakpoint(xs) {
                width: 100%;
                padding: 0 15px;
            }
        }

        &__type-filter {
            height: 50px;
            padding-top: 10px;

            .v-text-field {
                margin-top: 0px !important;
                padding-top: 0px !important;
            }

            @include breakpoint(xs) {
                padding: 10px 10px 0 0;
            }
        }
    }

    .v-btn--floating.v-btn--small {
        height: 50px !important;
        width: 50px !important;
    }
</style><style lang="scss">
    @import "../../common/styles/_colors.scss";
    @import "../../common/styles/_commonClasses.scss";
    @import "../../common/styles/_responsive.scss";

    .toolkit-block {
        &__search {
            margin-top: 7px;
            margin-bottom: 7px;
            color: $white;

            .v-input {
                &__slot {
                    margin: 0;
                    padding: 0px;
                    border: 2px solid $ypo-tile-border !important;
                }

                &__icon--clear {
                    .v-icon {
                        font-size: 14px;
                    }
                }

                input {
                    color: $white !important;
                    margin-top: 5px;
                }

                .v-input__append-inner {
                    margin-top: 8px;
                }

                &--is-focused {
                    background: $ypo_cta-secondary;
                }
            }
        }
    }

    .toolkit-search-scope {
        .v-input input {
            text-align: left !important;
            margin-top: 2px !important;
        }

        .v-text-field.v-text-field--enclosed .v-input__append-inner {
            margin-top: 8px !important;
        }

        .v-text-field--outline .v-label {
            top: 8px !important;
        }
    }

    .meetings-popup {
        .v-input input {
            text-align: left;
        }
    }
    .hidden-overlay {
        position: relative;
        height: 20px;
        z-index: 1;
        &:after {
            content: "";
            position: absolute;
            background-color: white;
            width: 100%;
            height: 100%;
            left: -1px;
            top: -1px;
            z-index: 1;
        }
        input {
            height: 5px;
        }
    }
</style>
